import React from "react"
import { DragDropContainer } from 'react-drag-drop-container';
import { Resizable, ResizableBox } from 'react-resizable';
import './DragAndResize.css';

export default class DragAndResize extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            noDragging: false,
            clipperWidth: 100,
            maxWidth: 1000,
        };
        this.startX = null;
        this.dcRef = React.createRef();
    }
    componentDidMount() { }
    componentWillReceiveProps(np) { }

    onDragStart(dragData) {
        console.log("onDragStart");
        this.setState({ noDragging: false })
    }
    onDrag(dragData, currentTarget, x, y) {
        if (this.startX === null) {
            this.startX = x;
        }
        //this.dcRef => clipper Box
        //this.dcRef.parentElement.parentElement => ResizableBox
        //this.dcRef.parentElement.parentElement.parentElement => DragDropContainer
        //this.dcRef.parentElement.parentElement.parentElement.parentElement => True Parent from other component
        var parentComponent = this.dcRef.current.parentElement.parentElement.parentElement.parentElement;
        var dragContainer = this.dcRef.current.parentElement.parentElement.parentElement;

        var clientWidth = parentComponent.clientWidth;//860;//672
        var maxLeft = clientWidth - this.dcRef.current.parentElement.clientWidth;
        var offsetLeft = this.dcRef.current.parentElement.parentElement.offsetLeft;
        //console.log("onDrag",dragData,currentTarget,x,y);
        //console.log("this.dcRef.current.parentElement.offsetLeft",this.dcRef.current.parentElement.offsetLeft,this.dcRef.current.parentElement.clientWidth);
        //console.log("this.dcRef.current.parentElement.parentElement",this.dcRef.current.parentElement.parentElement.clientWidth);
        //console.log("dragContainer.style.left",dragContainer.style.left,offsetLeft);
        var maxWidth = clientWidth - offsetLeft;
        this.setState({ maxLeft });
        console.log(clientWidth)
        if (offsetLeft < 0) {
            if (this.startX - x > 0) { //moving <- left so stop it, else continue so we don't get stuck
                this.setState({ noDragging: true })
            }
        }
        if (offsetLeft > maxLeft) {
            if (this.startX - x < 0) { //moving -> right so stop it, else continue so we don't get stuck
                this.setState({ noDragging: true })
            }
        }
    }
    onDragEnd(dragData, currentTarget, x, y) {
        console.log("onDragEnd");
        this.startX = null;
        this.setState({ noDragging: false })
    }
    onResize(event, { element, size }) {
        this.setState({ clipperWidth: size.width });
    }
    onResizeStart(event, data) {
        console.log("onResizeStart");
        this.setState({ noDragging: true });
    }
    onResizeStop(event, data) {
        console.log("onResizeStop");
        this.setState({ noDragging: false });
    }

    render() {
        let maxWidth = this.state.maxWidth;
        if (maxWidth == -1 && this.dcRef.current && this.dcRef.current.parentElement.parentElement.parentElement.parentElement.clientWidth) {
            maxWidth = this.dcRef.current.parentElement.parentElement.parentElement.parentElement.clientWidth;
        }
        return (
            <DragDropContainer style={{ width: "1000px", height: "1000px" }} xOnly={true} noDragging={this.state.noDragging}
                onDrag={this.onDrag.bind(this)}
                onDragStart={this.onDragStart.bind(this)}
                onDragEnd={this.onDragEnd.bind(this)}
            >
                <ResizableBox width={this.state.clipperWidth} height={30} axis={"x"}
                    maxConstraints={[maxWidth, 30]}
                    onResize={this.onResize.bind(this)}
                    onResizeStart={this.onResizeStart.bind(this)}
                    onResizeStop={this.onResizeStop.bind(this)}
                >
                    <div ref={this.dcRef} id={this.props.id ? this.props.id : ""} className={"tl-drag-and-resize " + (this.props.className ? this.props.className : "")}
                        style={{ width: this.state.clipperWidth + "px" }}>
                    </div>
                </ResizableBox>
            </DragDropContainer>

        )
    }
}